const About = () => <div className="page-container">
    <h2>About Me</h2>
    <div className="panel panel-default my-panel">
        <div className="panel-body">
            <p>Coming soon!</p>
        </div>
    </div>
</div>;

export default About;